import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import * as authService from "../../service/AuthService";
import * as apiService from "../../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ActionType, Slug, UrlParam } from "../../constants";
import { fixPathname, messageDtStr, getLatestId } from "../../utils/utils";
import {
  loadJobs,
  setRecipient,
  throwNotFound,
  updateNewCompanyData,
  updateNewCompanyTableData,
} from "../../utils/actionUtils";

const pathsRequiringMessages = [Slug.inbox];

const reloadWaitTime = (reloadsWithoutUserAction) => {
  return Math.min(10000, 1000 * reloadsWithoutUserAction);
};

const GlobalMessagesLoader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const auth = useSelector((state) => state.auth);
  const messages = useSelector((state) => state.messages);
  const allChats = messages.allChats;
  const numLocalMessages = messages.numLocalMessages;
  const [reloadsWithoutUserAction, setReloadsWithoutUserAction] = useState(0);

  const [reloadTimeout, setReloadTimeout] = useState(null);

  const loggedIn = auth.testing
    ? true
    : auth.accountData.loginToken !== null &&
      auth.accountData.contactInfo !== null;
  useEffect(() => {
    let shouldExit = false;
    if (auth.testing) shouldExit = true;
    if (!loggedIn) shouldExit = true;
    if (shouldExit) {
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      return;
    }

    // check if we need to load messages
    let pathRequiresMessages = false;
    if (pathsRequiringMessages.includes(fixPathname(location.pathname))) {
      pathRequiresMessages = true;
    }

    // load messages for the first time
    if (pathRequiresMessages && allChats === null) {
      console.log("loading messages info");
      apiService.getChats(
        dispatch,
        { ...auth.accountData },
        {
          // handleSuccess: (data) => {
          //   console.log("messages:", data);
          // },
        }
      );
    }

    // set a timer to check for new allChats (sidebar updates)
    if (pathRequiresMessages && allChats !== null) {
      console.log(
        "setting allChats Reload timer",
        reloadWaitTime(reloadsWithoutUserAction)
      );
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      const newReloadTimeout = setInterval(() => {
        console.log("reloading allChats", messageDtStr());
        const latestId = getLatestId(allChats);
        apiService.getChats(dispatch, { ...auth.accountData, latestId }, {});
      }, 10000);
      // building this
      // test, increase backoff
      setReloadTimeout(newReloadTimeout);
    }
  }, [loggedIn, fixPathname(location.pathname), allChats]);

  useEffect(() => {
    // if messages.recipient is set, check fullyLoaded
    // if not fullyLoaded, request the chat history
    if (messages.recipient && !messages.fullyLoaded) {
      console.log("requesting chat history", messages.recipient);
      apiService.getFullChat(
        dispatch,
        { ...auth.accountData, recruiterId: messages.recipient.userId },
        {}
      );
    }
  }, [messages.recipient, messages.fullyLoaded]);
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        position: "fixed",
      }}
    />
  );
};

export default GlobalMessagesLoader;
